import request from 'utils/request';
import { stringify } from 'qs';

export function login(data) {
  return request({
    url: '/api/customer/login',
    method: 'post',
    data: stringify(data),

  })
}
export function loginQr() {
  return request({
    url: '/api/wx/loginQr',
    method: 'get'
  })
}
export function queryLogined(param) {
  return request({
    url: `/api/wx/queryLogined?uuid=${param.uuid}`,
    method: 'get'
  })
}
export function logout() {
  return request({
    url: '/api/customer/logout',
    method: 'get'
  })
}
// export function getInfo(token) {
//   return request({
//     url: 'user/info',
//     method: 'get',
//     params: { token }
//   })
// }
export function getUserSectionInfoByToken() {
  return request({
    url: '/api/customer/myInfo',
    method: 'get'
  })
}
// export function getRoutes(token) {
//   return request({
//     url: '/sys/permission/getUserPermissionByToken',
//     method: 'get',
//     params: { token }
//   })
// }
export function save(params) {
  return request({
    url: '/api/user/create',
    method: 'post',
    data: params
  })
}
export function knockOut(param) {
  return request({
    url: '/api/user/kickOut?id=' + param,
    method: 'get'
  })
}
export function resetPwd(param) {
  return request({
    url: '/api/user/resetPwd?id=' + param.id,
    method: 'get'
  })
}
export function del(params) {
  return request({
    url: '/api/user/delete/' + params,
    method: 'get'
  })
}
// export function userRoleList(params) {
//   return request({
//     url: '/sys/user/userRoleList',
//     method: 'get',
//     params
//   })
// }
export function userList(params) {
  return request({
    url: '/api/user/',
    method: 'get',
    params
  })
}

export function checkAddressAndAccount(){
  return request({
    url: `/api/customer/checkAddressAndAccount`,
    method: 'get'
  })
}

export function getAddressesByCustomerId(customerId) {
  return request({
    url: `/api/customer/getCustomerAddresses?customerId=${customerId}`,
    method: 'get'
  })
}

export function addCustomerAddress(data) {
  return request({
    url: '/api/customer/addCustomerAddress',
    method: 'post',
    data: data
  })
}

export function deleteAddress(param) {
  return request({
    url: `/api/customer/deleteAddress/${param.addressId}`,
    method: 'get'
  })
}

export function updateCustomerAddress(data) {
  return request({
    url: '/api/customer/updateCustomerAddress',
    method: 'post',
    data: data
  })
}

export function updateAddressFlag(param) {
  return request({
    url: `/api/customer/updateAddressFlag/${param.addressId}`,
    method: 'get'
  })
}

export function addPayAccount(data) {
  return request({
    url: '/api/customer/addPayAccount',
    method: 'post',
    data: data
  })
}

export function updatePayAccount(data) {
  return request({
    url: '/api/customer/updatePayAccount',
    method: 'post',
    data: data
  })
}

export function deletePayAccount(param) {
  return request({
    url: '/api/customer/deletePayAccount/' + param.payAccountId,
    method: 'get'
  })
}

export function getPayAccounts(customerId) {
  return request({
    url: `/api/customer/getPayAccounts?customerId=${customerId}`,
    method: 'get'
  })
}

export function updatePayAccountFlag(param) {
  return request({
    url: '/api/customer/updatePayAccountFlag/' + param.payAccountId,
    method: 'get'
  })
}


export function getPayAccountByOrderId(param) {
  return request({
    url: `/api/customer/getPayAccountByOrderId/${param.orderId}`,
    method: 'get'
  })
}

export function getAddressByOrderId(param) {
  return request({
    url: `/api/customer/getAddressByOrderId/${param.orderId}`,
    method: 'get'
  })
}

export function passwordReset(data) {
  return request({
    url: '/api/customer/changePwd',
    method: 'post',
    data: stringify(data)
  })
}
export function changeUserInfo(data) {
  return request({
    url: '/api/customer/update',
    method: 'post',
    data: data
  })
}

//优惠使用规则
export function getPreferentialRule() {
  return request({
    url: '/api/customer/getPreferentialRule',
    method: 'get'
  })
}

export function batchImportAddress(params, data) {
  return request({
    url: `/api/customer/batchImportAddress/${params.userId}`,
    method: 'post',
    params,
    data: data,
  })
}
